import axios from "axios";

// Base URL configuration
// During development, we point to the React Dev Proxy or directly to the Django backend
const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-type": "application/json",
    },
});

export const getPersonalInfo = async (lang: string = "fr") => {
    const response = await apiClient.get(`/personal-info/?lang=${lang}`);
    if (response.data && response.data.length > 0) {
        return response.data[0]; // Assuming it returns a list and we want the first match
    }
    return null;
};

export const getExperience = async (lang: string = "fr") => {
    const response = await apiClient.get(`/work-experience/?lang=${lang}`);
    return response.data;
};

export const getProjects = async (lang: string = "fr") => {
    const response = await apiClient.get(`/projects/?lang=${lang}`);
    return response.data;
};

export const getEducation = async (lang: string = "fr") => {
    const response = await apiClient.get(`/education/?lang=${lang}`);
    return response.data;
};

export const getSkills = async () => {
    const response = await apiClient.get(`/skills/`);
    return response.data;
};

export const getLanguages = async () => {
    const response = await apiClient.get(`/languages/`);
    return response.data;
};

export const getPublications = async (lang: string = "fr") => {
    const response = await apiClient.get(`/publications/?lang=${lang}`);
    return response.data;
};

export default {
    getPersonalInfo,
    getExperience,
    getProjects,
    getEducation,
    getSkills,
    getLanguages,
    getPublications,
};
